import { apiClient } from '../services/api-client';
import type { FoodOrderCancelResponse } from '../types/food';

/**
 * DELETEs a foodcourt endpoint.
 *
 * The response is unvalidated JSON, so `TResponse` is an unchecked claim confined
 * to this boundary rather than validation — see the note in `LyticsFetcher`. It
 * defaults to {@link FoodOrderCancelResponse}: both call sites are the same
 * `/order/sb/{vendorOrderId}` cancellation and read the reply the same way,
 * `response === ''` for success and `title`/`detail` otherwise.
 */
const FoodDelete = async <TResponse = FoodOrderCancelResponse>(
  endPoint: string,
  token: string,
): Promise<TResponse> => {
  const result = await apiClient.del<TResponse>(
    import.meta.env.VITE_FOODCOURT_API_NAME,
    endPoint,
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    },
  );
  return result;
};

export default FoodDelete;
